<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container">

    <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

    <div class="row mb-3">
      <div class="col-12">
        <h1 [ngClass]="{'page-title': useRebrandedLayout }" class="text-center mt-4">
          Change account email
        </h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 text-center mt-2 mb-3">
        <h5 [ngClass]="{'page-title': useRebrandedLayout }">
          To change your email address, please fill in the fields below:
        </h5>
      </div>
    </div>

    <div class="row mb-5">
      <div [ngClass]="useRebrandedLayout ? 'mx-auto mb-3 col-md-6' : 'col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4 mb-3'">

        <form
          #updateEmailForm="ngForm"
          [appMatchingFields]="['emailNew', 'emailNewConfirm']"
          (ngSubmit)="save(updateEmailForm)"
          novalidate>
          <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">

            <div class="mb-3">
              <label class="form-label" for="emailCurrent">
                Current email address
              </label>
              <input
                class="form-control"
                name="emailCurrent"
                [ngModel]="user.contact.email"
                placeholder="Current email address"
                readonly
                type="email">
            </div>

            <div class="mb-3">
              <label class="form-label" for="emailNew">
                New email address
              </label>
              <input
                #emailNew="ngModel"
                class="form-control"
                [class.is-invalid]="emailNew.touched && !emailNew.valid"
                [emailDot]="true"
                id="emailNew"
                name="emailNew"
                [(ngModel)]="model.emailAddress"
                placeholder="New email address"
                required
                type="email">
              <div
                *ngIf="emailNew.errors && emailNew.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
              <div
                *ngIf="emailNew.errors && emailNew.errors.email"
                class="invalid-feedback">
                {{ errorStrings.emailInvalid }}
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="emailNewConfirm">
                Confirm new email address
              </label>
              <input
                #emailNewConfirm="ngModel"
                class="form-control"
                [class.is-invalid]="emailNewConfirm.touched && !emailNewConfirm.valid"
                [emailDot]="true"
                id="emailNewConfirm"
                name="emailNewConfirm"
                ngModel=""
                placeholder="New email address"
                required
                type="email">
              <div
                *ngIf="emailNewConfirm.errors && emailNewConfirm.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
              <div
                *ngIf="emailNewConfirm.errors && emailNewConfirm.errors.email"
                class="invalid-feedback">
                {{ errorStrings.emailInvalid }}
              </div>
              <div
                *ngIf="emailNewConfirm.errors && emailNewConfirm.errors.matchingFields"
                class="invalid-feedback">
                {{ errorStrings.emailMismatch }}
              </div>
            </div>

            <div>
              <label class="form-label" for="passwordCurrent">
                Current password
              </label>
              <input
                #passwordCurrent="ngModel"
                class="form-control"
                [class.is-invalid]="passwordCurrent.touched && !passwordCurrent.valid"
                id="passwordCurrent"
                minlength="8"
                name="passwordCurrent"
                [(ngModel)]="model.password"
                placeholder="Current password"
                required
                type="password">
              <div
                *ngIf="passwordCurrent.errors && passwordCurrent.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
              <div
                *ngIf="passwordCurrent.errors && passwordCurrent.errors.minlength"
                class="invalid-feedback">
                {{ errorStrings.passwordTooShort }}
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <button
              class="btn btn-success text-white btn-lg mt-5"
              [ngClass]="useRebrandedLayout ? 'w-75' : 'w-100'"
              [disabled]="!updateEmailForm.valid || loading"
              type="submit">
              <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'"class="me-3"></fa-icon>
              {{ loading ? 'Updating' : 'Update' }}
            </button>
          </div>
        </form>

      </div>
    </div>

    <div class="row">
      <div class="col-12 d-flex justify-content-start mb-3">
        <a [routerLink]="['/account']">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back to my account
        </a>
      </div>
    </div>
  </div>
</div>
